const LAYER_CLASSNAME_PREFIX = "layer";

export enum Layer {
    HIGH_ALERT = "high-alert",
    MODAL = "modal",
    NAVIGATION = "navigation",
    OVERLAY = "overlay",
    ICONS = "icons",
    BASE = "base"
}

const removeLayerClasses = <TElement extends HTMLElement>(
    element: TElement
) => {
    element.classList.forEach((className) => {
        if (!className.startsWith(LAYER_CLASSNAME_PREFIX)) return;
        element.classList.remove(className);
    });
};

const applyLayer = <TElement extends HTMLElement>(
    element: TElement,
    layer: Layer,
    layerAbove: boolean
) => {
    const layerToApply = layerAbove ? layer : `${layer}-1`;
    element.classList.add(`layer-${layerToApply}`);
};

const setLayer = <TElement extends HTMLElement>(
    element: TElement,
    layer: Layer,
    layerAbove: boolean = false
) => {
    removeLayerClasses(element);
    applyLayer(element, layer, layerAbove);
};

export { setLayer };
